module.exports = __webpack_public_path__ + "img/refresh.8fb392f8.png";